import { makeStyles } from '@material-ui/core';

interface FilterChipProps {
  label: string;
  color: { bg: string; text: string };
  onRemove?: () => void;
  onClick?: () => void;
  maxWidth?: number;
}

const useStyles = makeStyles({
  chip: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    padding: '8px 10px',
    borderRadius: 15,
    fontSize: 13,
    fontWeight: 500,
    transition: 'transform 0.15s, opacity 0.15s',
    userSelect: 'none',
    WebkitUserSelect: 'none',
    whiteSpace: 'nowrap',
    '@media (hover: hover)': {
      '&:hover': {
        opacity: 0.8,
      },
    },
    '&:active': {
      transform: 'scale(0.95)',
      opacity: 0.65,
    },
  },
  removeButton: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    // Visual size stays 16px, but padding expands hit area
    width: 16,
    height: 16,
    borderRadius: '50%',
    fontSize: 10,
    fontWeight: 700,
    cursor: 'pointer',
    lineHeight: 1,
    color: 'white',
    padding: 0,
    margin: '-4px -4px -4px 0',
    // Expand click target via pseudo-element
    position: 'relative' as const,
    opacity: 0.6,
    transition: 'transform 0.12s, opacity 0.12s',
    '&::before': {
      content: '""',
      position: 'absolute' as const,
      top: -4,
      right: -4,
      bottom: -4,
      left: -4,
    },
    '@media (hover: hover)': {
      '&:hover': {
        opacity: 1,
      },
    },
    '&:active': {
      transform: 'scale(0.9)',
    },
  },
});

const FilterChip = ({ label, color, onRemove, onClick, maxWidth }: FilterChipProps) => {
  const classes = useStyles();
  return (
    <div
      className={classes.chip}
      onClick={onClick}
      style={{
        backgroundColor: color.bg,
        color: color.text,
        cursor: onClick ? 'pointer' : 'default',
      }}
    >
      <span style={maxWidth ? { overflow: 'hidden', textOverflow: 'ellipsis', maxWidth } : undefined}>{label}</span>
      {onRemove && (
        <span
          className={classes.removeButton}
          onClick={e => { e.stopPropagation(); onRemove(); }}
          style={{ backgroundColor: color.text }}
        >
          ×
        </span>
      )}
    </div>
  );
};

export default FilterChip;
